import React, { Fragment, ReactElement, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import API from '@sesame/web-api';

import Alert, { AlertTypes } from 'src/components/AlertDisplay';
import ModalDialog from 'src/components/ModalDialog';
import { FormInput } from 'src/components/Form';
import { ILoadState, IRack, IArenaPart } from 'src/types';
import { PartInput } from './PartInput';
import { Spinner } from 'src/components/Spinner';

type IFormData = { [Property in keyof IRack]: string; } & { [key: string]: string };
type fieldNames = keyof IFormData;

interface IAddRackProps {
  salesorderId: number;
  onSave?: () => void;
}

export const AddRack = ({ salesorderId, onSave }: IAddRackProps) => {
  return <ModalDialog
    id="newrack"
    title={`Add Rack - Sales Order ${salesorderId}`}
    buttonText="Add Rack">
    <AddRackForm
      salesorderId={salesorderId}
      onSave={onSave}
    />
  </ModalDialog>
}
export const AddRackForm = ({ salesorderId, onSave }: IAddRackProps) => {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const [formData, setFormData] = useState<IFormData>({
    rackId: "0",
    salesorderId: '' + salesorderId,
    bomPartNumber: '',
    revision: '',
    arenaGuid: '',
    identifier: '',
    description: '',
  })
  const [arenaPart, setArenaPart] = useState<IArenaPart>();
  const [validation, setValidation] = useState<fieldNames[]>([]);
  const [partDisplayState, setPartDisplayState] = useState<ILoadState>(ILoadState.NEW);

  const formChange = (item: fieldNames, event: React.FormEvent<HTMLInputElement | HTMLSelectElement>) => {
    const newFormData = { ...formData };
    newFormData[item] = event.currentTarget.value;

    setFormData(newFormData);
  }


  const validate = () => {
    const errors: fieldNames[] = [];

    if (formData.bomPartNumber == '') {
      errors.push('bomPartNumber');
    }
    if (formData.identifier == '') {
      errors.push('identifier');
    }
    setValidation(errors);
    return errors.length;
  }

  const save = (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault();

    if (validate() > 0) {
      return;
    }

    const newRack: IRack = {
      rackId: +formData.rackId,
      salesorderId: salesorderId,
      bomPartNumber: formData.bomPartNumber,
      revision: formData.revision,
      arenaGuid: formData.arenaGuid,
      identifier: formData.identifier,
      description: formData.description,
    }

    getAccessTokenSilently().then(accessToken => {
      API.post(accessToken, `/api/v1/rack`, newRack, { timeout: 6000 })
        .then((res) => {
          Alert(AlertTypes.SUCCESS, "Rack Saved");
          if (onSave) {
            onSave();
          }
          const el = document.getElementById('newrack');
          if (el) {
            el.click()
          }
        })
        .catch((err) => {
          Alert(AlertTypes.ERROR, "Error saving rack: " + err.message);
        });
    })
  }

  if (isLoading) {
    return <Spinner />
  }
  return <form>
    <FormInput
      label="Identifier / Reference"
      name="identifier"
      changeFn={formChange}
      data={formData}
      validation={validation}
    />
    <FormInput
      label="Description"
      name="description"
      changeFn={formChange}
      data={formData}
      validation={validation}
    />
    <PartInput
      partNumber={formData.bomPartNumber}
      partFilter='TLA'
      onChange={(p, r) => {
        const fd = formData;
        fd.bomPartNumber = p.number;
        fd.revision = r.number;
        fd.arenaGuid = r.guid;
        setFormData(fd);
      }}
    />
    <p className="uk-text-right">
      <button
        className="uk-button uk-button-primary uk-button-small"
        data-uk-toggle="newrack"
        onClick={(e) => save(e)}>
        Save
      </button>
    </p>

  </form>
}
